interface InputSize {
  top: string;
  right: string;
}
// input组件
export const inputSize = (size: string): InputSize => {
  const info: InputSize = { top: "", right: "" };
  if (size === "default") {
    info.right = "right-2";
    info.top = "top-[10px]";
  } else if (size === "sm") {
    info.right = "right-3";
    info.top = "top-[10px]";
  } else {
    info.right = "right-4";
    info.top = "top-[13px]";
  }
  return info;
};
